/** NOTE: this file is used by WorkflowService.js
 * do not use it directly in other files, at least until we convert WorkflowService.js to typescript
 */

import { Workflow } from '@ply-io/ply-front-shared-utilities';

const isTempHidden = (wf: Workflow) => {
	if (wf.user_settings.hide_until) {
		const curDate = new Date();
		const hideUntil = new Date(wf.user_settings.hide_until);
		return hideUntil > curDate;
	}
	return false;
};
export const needToShowWorkflow = (wf: Workflow) => wf.is_active && !isTempHidden(wf) && wf.user_settings.is_on;
